import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store/index';
import Video from 'video.js';
import ElementUI from 'element-ui';
import submit from './utils/submit';
import VueClipBoard from 'vue-clipboard2';

import 'lib-flexible';
import 'lib-flexible/flexible.js';

import '../static/siyuan/font.css';
import 'element-ui/lib/theme-chalk/index.css';
import "swiper/css/swiper.min.css";
import 'video.js/dist/video-js.css';
import "@/assets/css/commot.css";

Vue.config.productionTip = false;
Vue.prototype.$submit = submit;
Vue.use(ElementUI);
Vue.use(VueClipBoard);
Vue.prototype.$store = store;
Vue.prototype.$bus = new Vue();
Vue.prototype.$video = Video;

new Vue({ el: '#app', router, components: { App }, template: '<App/>' });



// WEBPACK FOOTER //
// ./src/main.js